import React, { useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import PropTypes from 'prop-types';
import {
  StyledSection,
  StyledContentBlock,
  Title,
  Subtitle,
  QrWrapper,
  ApptoreButton,
  GooglplayButton,
  MobileButton,
  QrIcon,
  Icon,
  TotalImageWrapper,
  BackGroundWrapper,
  Contentwrapper,
  TotalImageWrapperTablet,
  TotalImageWrapperMobile,
} from './styled';

import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../../../components/QrCodeModal/styled';
import StoreToggle from '../../../components/QrCodeModal/StoreToggle';
import WalletsCreated from '../WalletsCreated';
import { useBranchLink } from '../../../helpers/branchLink';

const Header = ({ template }) => {
  const { messages, locale } = useIntl();
  const modalRef = useRef();
  const [selectedStore, setSelectedStore] = useState('GOOGLE_PLAY');

  const mobileButtonLink = useBranchLink({
    branch: messages[`${template}.header.link.mobile_button`],
    android: messages[`${template}.header.link.googleplay`],
    iOS: messages[`${template}.header.link.appstore`],
    fallback: messages[`${template}.header.link.mobile_button`],
  });

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? messages['global.qrcodeModal.google-play.link']
      : messages['global.qrcodeModal.app-store.link'];

  return (
    <StyledSection>
      <StyledContentBlock>
        <BackGroundWrapper>
          <TotalImageWrapper
            src={messages[`${template}.header.hero_desktop`]}
            alt={messages[`${template}.header.title`]}
          />
          <TotalImageWrapperTablet
            src={messages[`${template}.header.hero_tablet`]}
            alt={messages[`${template}.header.title`]}
          />
          <TotalImageWrapperMobile
            src={messages[`${template}.header.hero_mobile`]}
            alt={messages[`${template}.header.title`]}
          />
        </BackGroundWrapper>

        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id={`${template}.header.title`} />
          </Title>
          <Subtitle>
            <FormattedMessage id={`${template}.header.subtitle`} />
          </Subtitle>

          <QrWrapper>
            <ApptoreButton
              href={messages[`${template}.header.link.appstore`]}
              target="_blank"
            >
              <Icon
                src={messages[`${template}.header.appstore_image`]}
                alt="App Store"
              />
            </ApptoreButton>

            <GooglplayButton
              href={messages[`${template}.header.link.googleplay`]}
              target="_blank"
            >
              <Icon
                src={messages[`${template}.header.googleplay_image`]}
                alt="Google Play"
              />
            </GooglplayButton>

            <QrIcon
              className="ga-wallet-cta get-app-cta-button"
              onClick={() => modalRef.current?.open()}
              src={messages[`${template}.header.qr_image`]}
              alt="QR Code"
            />
          </QrWrapper>
        </Contentwrapper>

        <MobileButton target="_blank" href={mobileButtonLink}>
          <FormattedMessage id={`${template}.header.mobile_button`} />
        </MobileButton>
        <ModalWrapper>
          <Modal ref={modalRef}>
            <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
            <StyledSubtitle>
              {messages['global.qrcodeModal.description']}
            </StyledSubtitle>
            <StoreToggle
              selectedStore={selectedStore}
              setSelectedStore={setSelectedStore}
            />
            <QrCodeWrapper>
              <QRCode value={qrValue} />
            </QrCodeWrapper>
          </Modal>
        </ModalWrapper>
      </StyledContentBlock>
      <WalletsCreated template={template} />
    </StyledSection>
  );
};

Header.propTypes = {
  template: PropTypes.string.isRequired,
};

export default Header;
